import { ServiceInfo } from '../display/serviceInfo';

// export class UserLogin {
//     constructor(
        
//     ) {
//     }
// }

export class  UserApi {
    public static copyFromApi(response) {
        return new UserApi(
            response.autopartage,
            response.birthdate,
            response.caution,
            response.cgu_ok,
            response.community,
            response.company,
            response.country,
            response.covoiturage,
            response.currency,
            response.customer_id,
            response.customer_name,
            response.email,
            response.firstname,
            response.id,
            response.is_admin,
            response.is_animator,
            response.is_incidence,
            response.is_maintenance,
            response.is_suspended,
            response.lastname,
            response.name,
            response.other_communities,
            response.partage_trajet,
            response.paymode,
            response.permis,
            response.phonenumber,
            response.photo,
            response.profile_picture,
            response.recharge,
            response.rfid,
            response.service_gare,
            response.solde,
            response.tad_animator,
            response.tad_driver,
            response.tad_user,
            response.territory,
            response.url_formula,
            response.velo,
            response.license,
            response.license_back,
            response.attachments,
            response.selfie_file,
            response.link_to_inform_page,
            response.total_comunity_drivers,
        );
    }

    constructor(
        public autopartage: boolean,
        public birthdate: string,
        public caution: boolean,
        public cgu_ok: boolean,
        public community: any,
        public company: any,
        public country: string,
        public covoiturage: boolean,
        public currency: string,
        public customer_id: number,
        public customer_name: string,
        public email: string,
        public firstname: string,
        public id: number,
        public is_admin: boolean,
        public is_animator: boolean,
        public is_incidence: boolean,
        public is_maintenance: boolean,
        public is_suspended: boolean,
        public lastname: string,
        public name: string,
        public other_communities: [],
        public partage_trajet: boolean,
        public paymode: string,
        public permis: boolean,
        public phonenumber: string,
        public photo: any,
        public profile_picture: any,
        public recharge: boolean,
        public rfid: string,
        public service_gare: boolean,
        public solde,
        public tad_animator: boolean,
        public tad_driver: boolean,
        public tad_user: boolean,
        public territory: any,
        public url_formula: string,
        public velo: boolean,
        public license: any,
        public total_comunity_drivers: any,
        public license_back: any,
        public attachments: any,
        public selfie_file: any,
        public link_to_inform_page: any,
    ) {
    }

    public  getUserServices() : ServiceInfo[] {
        let services = [];
        // console.error(this);
        if (this.autopartage) {
            services.push(ServiceInfo.buildAutopartage());
        }
        if (this.recharge) {
            services.push(ServiceInfo.buildRecharge());
        }
        if (this.partage_trajet) {
            services.push(ServiceInfo.buildPartageTrajet());
        }
        return services;
    }
}

export class BilanEcoLine {
    constructor(
        public startdate : string,
        public enddate : string,
        public duration : number,
        public bilan : number,
        public booking_id : number,
        public km : number
    ) {
        
    }
}

export class BilanEco {
    constructor(
        public total_duration: number,
        public total_km: number,
        public total_bilan: number,
        public list : BilanEcoLine[]
    ) {
        
    }
}

export class Contract {
    constructor(
        public allowed_drivers: number,
        public package_name : string,
        public beginning: string,
        public package_beginning: any,
        public package_expiration: any,
        public package_validity: any,
        public solde: any,
        public cgus: string,
        public expiration: any,
        public validity: any,
        public url_change_package: string
    ) {}
}

export class UserBilan {
    constructor(
                public velo: boolean,
                public is_suspended: boolean,
                public phonenumber: string,
                public covoiturage: boolean,
                public cgu_ok: boolean,
                public id: number,
                public is_maintenance: boolean,
                public recharge: boolean,
                public partage_trajet: boolean,
                public is_incidence: boolean,
                public customer_id: number,
                public tad_animator: boolean,
                public firstname: string,
                public service_gare: boolean,
                public lastname: string,
                public company: string,
                public rfid: string,
                public birthdate: string,
                public profile_picture:any,
                public is_admin: boolean,
                public is_animator: boolean,
                public autopartage: boolean,
                public name: string,
                public tad_driver: boolean,
                public email: string,
                public permis: boolean,
                public caution: boolean,
                public tad_user: boolean,
                public paymode: string,
                public solde: any,
                public customer_name: string,
                public photo: string,
                public currency: string,
                public contract: Contract,
                public drivers: any,
                public cgus: string,
                public country: string,
                public community: any,
                public territory: any,
                public other_communities: any,
                public total_comunity_drivers: any,
    ) {

    }
}